import { createSlice } from "@reduxjs/toolkit";
import {
  addToCartAPI,
  // updateToCartAPI,
  fetchCartAPI,
  removeFromCartAPI,
} from "./thunk";
import { toast } from "sonner";

const initialState = {
  cart: [],
  isLoading: false,
  error: "",
};

export const itemCartSlice = createSlice({
  name: "itemCart",
  initialState,
  reducers: {
    addItemToCart: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      const existingItem = state.cart.find(
        (item) => item.id === action.payload.id,
      );

      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.cart.push({ ...action.payload, quantity: 1 });
      }
      toast.success("Item added to cart.");
      state.error = "";
    },
    removeItemFromCart: (state, action) => {
      const existingItem = state.cart.find(
        (item) => item.id === action.payload,
      );
      if (!existingItem) return;

      if (existingItem.quantity > 1) {
        existingItem.quantity -= 1;
      } else {
        state.cart = state.cart.filter((item) => item.id !== action.payload);
      }
      state.error = "";
    },
    increaseQty: (state, action) => {
      const item = state.cart.find((item) => item.id === action.payload.id);

      if (item) {
        item.quantity += 1;
      }
      state.error = "";
    },
    deleteItemFromCart: (state, action) => {
      const existingItem = state.cart.find(
        (item) => item.id === action.payload,
      );

      if (!existingItem) return;

      state.cart = state.cart.filter((item) => item.id !== action.payload);
      state.error = "";
    },
    clearLocalCart: (state) => {
      state.cart = [];
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch cart
      .addCase(fetchCartAPI.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCartAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cart = action.payload?.shoppingCart?.items ?? [];
      })
      .addCase(fetchCartAPI.rejected, (state, action) => {
        state.isLoading = false;
      })

      // add to cart
      .addCase(addToCartAPI.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(addToCartAPI.fulfilled, (state, action) => {
        const existingItem = state.cart.find(
          (item) => item.productId === action.payload.productId,
        );

        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          state.cart.push({ ...action.payload, quantity: 1 });
        }
        toast.success("Item added to cart.");
        state.error = "";
        state.isLoading = false;
      })
      .addCase(addToCartAPI.rejected, (state, action) => {
        console.log(action?.payload);
        state.error = action?.payload?.message || "error adding item to cart";
        toast.error(action?.payload?.message || "error adding item to cart");
        state.isLoading = false;
      })
      // .addCase(updateToCartAPI.fulfilled, (state, action) => {
      //   const existingItem = state.cart.find(
      //     (item) => item.productId === action.payload.id,
      //   );

      //   if (existingItem) {
      //     existingItem.quantity += 1;
      //   } else {
      //     state.cart.push({ ...action.payload, quantity: 1 });
      //   }
      // })
      // remove from cart
      .addCase(removeFromCartAPI.fulfilled, (state, action) => {
        const existingItem = state.cart.find(
          (item) => item.shoppingCartId === action.payload.id,
        );

        if (!existingItem) return;

        if (existingItem.quantity > 1) {
          existingItem.quantity -= 1;
        } else {
          state.cart = state.cart.filter(
            (item) => item.shoppingCartId !== action.payload.shoppingCartId,
          );
        }
        state.isLoading = false;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  addItemToCart,
  removeItemFromCart,
  increaseQty,
  deleteItemFromCart,
  clearLocalCart,
} = itemCartSlice.actions;

export default itemCartSlice.reducer;
